import { useState, useEffect } from 'react';

// ----------------------------------------------------------------------

// useState that survives navigation and page reloads by mirroring the value into sessionStorage.
// sessionStorage is per browser tab and is dropped when the tab is closed, so stale filters don't
// greet the user days later; logout also clears it (resetLocalStorage), so values never leak across users.
export default function usePersistedState(key, defaultValue) {
  const [value, setValue] = useState(() => {
    try {
      const stored = sessionStorage.getItem(key);
      return stored !== null ? JSON.parse(stored) : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Storage unavailable (private mode, quota) — keep working with in-memory state only
    }
  }, [key, value]);

  return [value, setValue];
}
